import { TPoint, TPointsByWorkspace } from '../points.model';

export function selectPointFromState(
  points: TPointsByWorkspace,
  workspaceId: string | undefined,
  pointId: string | undefined,
): TPoint | undefined {
  if (!workspaceId || !pointId) {
    return undefined;
  }

  return points?.[workspaceId]?.entities?.find((entity) => entity._id === pointId);
}
